export default __webpack_public_path__ + "static/frontpage-banner-bg-c40540d229de26885325a5e49ed4589a.webp";